import { useI18N } from "common/hooks";

/** Error state for /places and /places/<city>: keeps the #main landmark and one h1. */
export function PlacesUnavailable() {
  const i18n = useI18N();
  return (
    <main id="main" className="w-full bg-bg-brand-secondary-default">
      <div className="mx-auto flex max-w-[1160px] flex-col gap-2 px-4 py-6 md:py-10">
        <h1 className="headline-l-bold text-fg-neutral-strong">{i18n.get("placesUnavailableHeading")}</h1>
        <p role="alert" className="label-m-medium text-fg-neutral-subtle">{i18n.get("placesUnavailableMessage")}</p>
      </div>
    </main>
  );
}
